

import { t } from '@process-creative/slate-theme-tools';

//Selectors
const SELECTOR_OVERLAY = '[data-back-in-stock-drawer-overlay]'
export const SELECTOR_DRAWER = '[data-back-in-stock-drawer-container]'
const SELECTOR_OPEN_BTN = '[data-back-in-stock-drawer-open-btn]'
const SELECTOR_CLOSE_BTN = '[data-back-in-stock-drawer-close-btn]'
const SELECTOR_SUBSCRIBE = '[data-subscribe-checkbox]'
const SELECTOR_FORM = '[data-back-in-stock-form]'
const SELECTOR_EMAIL = '[data-email]'
const SELECTOR_VARIANT = '[data-variant-selector]'

//Attributes
const ATTR_KLAVIO_KEY = 'data-back-in-stock-form'

//Classes
const CLASS_HAS_FROZEN_SCROLL = 'has-frozen-scroll'
const CLASS_IS_HIDDEN = 'is-hidden'
const CLASS_IS_ACTIVE = 'is-active'
const CLASS_FADE_IN = 'animate-fade-in'
const CLASS_SLIDE_IN = 'animate-slide-in'
const CLASS_FADE_OUT = 'animate-fade-out'
const CLASS_SLIDE_OUT = 'animate-slide-out'


const BackInStockDrawer = (containerElem, productContainer) => {
  if(!containerElem.length) return

  const {closeDrawer} = setupOpenCloseEvents()
  handleFormSubmission()


  function setupOpenCloseEvents(){
    const overlayElem = $(SELECTOR_OVERLAY)
    const drawerElem = $(SELECTOR_DRAWER)

    $(SELECTOR_OPEN_BTN)
    .on('click touch', openDrawer)
  
    $(`${SELECTOR_CLOSE_BTN}, ${SELECTOR_OVERLAY}`)
    .on('click touch', closeDrawer)

    $(document).on('animationend', e => {
      const {animationName} = e.originalEvent

      switch(animationName){
        case 'fadeOut': {
          overlayElem.removeClass(CLASS_FADE_OUT)
          overlayElem.addClass(CLASS_IS_HIDDEN)
          $('body').removeClass(CLASS_HAS_FROZEN_SCROLL)
        }; break
        case 'fadeIn': {
          overlayElem.removeClass(CLASS_FADE_IN)
        }; break
        case 'slideInFromRight': {
          drawerElem.removeClass(CLASS_SLIDE_IN)
          drawerElem.addClass(CLASS_IS_ACTIVE)
        }; break
        case 'slideOutToRight': {
          drawerElem.removeClass(CLASS_SLIDE_OUT)
          drawerElem.addClass(CLASS_IS_HIDDEN)
          drawerElem.removeClass(CLASS_IS_ACTIVE)
        }; break
      }
    })

    function openDrawer(e) {
      e.preventDefault()

      overlayElem.removeClass(CLASS_IS_HIDDEN)
      containerElem.removeClass(CLASS_IS_HIDDEN)
  
      overlayElem.addClass(CLASS_FADE_IN)
      containerElem.addClass(CLASS_SLIDE_IN)
  
      $('body').addClass(CLASS_HAS_FROZEN_SCROLL)
    }

    function closeDrawer() {
      overlayElem.addClass(CLASS_FADE_OUT)
      containerElem.addClass(CLASS_SLIDE_OUT)
    }
    
    return {closeDrawer}
  }

  function handleFormSubmission(){
    const formElem = containerElem.find(SELECTOR_FORM)

    
    formElem.on('submit', e => {
      e.preventDefault()

      const variant = productContainer.find(SELECTOR_VARIANT).val()
      const email = $(SELECTOR_EMAIL).val()
      const subscribe = $(SELECTOR_SUBSCRIBE).is(':checked')
      
      const asyncEvents = []

      asyncEvents.push(
        submitBackInStock({variant, email})
      )

      if(subscribe){
        const data = $(SELECTOR_FORM).serialize()
        
        asyncEvents.push(
          subscribeToNewsletter(data)
        )
      }

      Promise.all(asyncEvents)
      .then(showResults)
      .then(() => setTimeout(closeDrawer, 3000))

    })



    function submitBackInStock({variant, email}){
      return new Promise(resolve => {

        const URL = 'https://a.klaviyo.com/onsite/components/back-in-stock/subscribe';
        const PLATFORM = 'shopify';
        const KEY = $(SELECTOR_FORM).attr(ATTR_KLAVIO_KEY);

        $.ajax({
          type: 'POST',
          dataType: 'json',
          url: URL,
          data: {
            a: KEY,
            email: email,
            variant: variant,
            platform: PLATFORM
          },
          success: response => 
            resolve({successful: response.success, response})
          ,
          error: error => 
            resolve({successful: false, response: error})
        });
      });
    }


    function subscribeToNewsletter(data){
      return new Promise(resolve => {
        $.ajax({  
          type: "POST",
          url: "/contact",
          data: data,
          success: response => 
            resolve({successful: response.success, response})
          ,
          error: error => 
            resolve({successful: false, response: error})
        }); 
      });
    }

    function showResults([bis, newsletter]){
      formElem.hide()
      const bisFeedback = `
        <ul>
          <li>
            ${bis.successful ?
              t('products.back_in_stock.success_message')
              : 
              t('products.back_in_stock.fail_message')
            }
          </li>
          ${newsletter ? `
            <li>
              ${newsletter.successful ?
                t('products.back_in_stock.newsletter_success_message')
                : 
                t('products.back_in_stock.newsletter_fail_message')
              }
            </li>`:''
          }
        </ul>
      `
      bisFeedback && 
        containerElem.append(bisFeedback)


    }


  }
}

export default BackInStockDrawer